// extracted by mini-css-extract-plugin
export default {"rating_container":"rating_rating_container__zrPyN","star":"rating_star__gbzFk","active":"rating_active__jF7SS","inactive":"rating_inactive__x1Ghl"};